import {useCallback, useRef, useState} from 'react';

export interface IContainerSize {
    width: number;
    height: number;
}
export const useContainerSize = () => {
    const [dimensions, setDimensions] = useState<IContainerSize>({
        width: 0,
        height: 0,
    });

    const previousObserver = useRef<ResizeObserver | null>(null);

    const customRef = useCallback((node: HTMLElement | null) => {
        if (previousObserver.current) {
            previousObserver.current.disconnect();
            previousObserver.current = null;
        }

        if (node?.nodeType === Node.ELEMENT_NODE) {
            const observer = new ResizeObserver(([entry]) => {
                if (entry && entry.borderBoxSize) {
                    const {inlineSize: width, blockSize: height} =
                        entry.borderBoxSize[0];

                    setDimensions({width, height});
                }
            });

            observer.observe(node);
            previousObserver.current = observer;
        }
    }, []);

    return [customRef, dimensions] as const;
};
